function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = Number(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      // 手动输入事件
      this.input.addEventListener('input', () => this.handleManualInput());
    }

    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();

      const limit = Number(this.dataset.limited);

      if (!isNaN(limit) && limit > 0) {
        // 限购：设置只读 + title 提示
        this.input.setAttribute('readonly', 'readonly');
        this.input.style.cursor = 'not-allowed';
        this.input.title = `This product is limited to ${limit} piece`;
      } else {
        // 非限购：可自由输入
        this.input.removeAttribute('readonly');
        this.input.style.cursor = '';
        this.input.removeAttribute('title');
      }
    }

    handleManualInput() {
      const limit = Number(this.dataset.limited);
      const min = Number(this.input.min) || 1;
      let value = Number(this.input.value);

      if (isNaN(value) || value < min) {
        value = min;
      }

      if (!isNaN(limit) && limit > 0 && value > limit) {
        alert(`This product is limited to ${limit} piece`);
        value = limit;
      }

      this.input.value = value;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }

    change_quantity(change) {
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;

      const min = Number(this.input.min) || 1;
      const limit = Number(this.dataset.limited);
      const maxAttr = Number(this.input.max) || Infinity;
      const max = !isNaN(limit) && limit > 0 ? limit : maxAttr;

      let newQuantity = Math.min(Math.max(quantity + change, min), max);

      // 只有数量变化时才触发事件
      if (newQuantity !== quantity) {
        this.input.value = newQuantity;
        this.input.dispatchEvent(this.changeEvent);
      }

      // 按钮状态始终刷新
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      const min = parseInt(this.input.min) || 1;
      const limit = Number(this.dataset.limited);
      const maxAttr = parseInt(this.input.max) || Infinity;
      const max = !isNaN(limit) && limit > 0 ? limit : maxAttr;

      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}


/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.secondary = this.querySelector('.product-secondary-image');
      this.image = this.secondary || this.querySelector('.product-primary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.getAttribute('disabled') != undefined) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}



/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');
      // Add functionality to buttons
      this.panel = this.closest('.side-panel');
      this.addEventListener('click', (e) => this.close_panel(e));
      this.addEventListener('keydown', (e) => this.close_panel(e));
      cc.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active, .open-search .search-drawer');

        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, side_panel) {
      let panel = this.panel;
      if (e.code && e.code.toUpperCase() !== 'ENTER') {
        return;
      }
      if (side_panel) {
        panel = side_panel;
      }
      if (!panel) {
        panel = document.querySelector('.side-panel.active');
      }
      if (panel) {
        panel.classList.remove('active');
      }
      if (document.body.classList.contains('open-cc--product')) {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => {
          document.querySelector('#Product-Drawer-Content').innerHTML = '';
        }, 260);
      } else if (panel?.classList.contains('cart-drawer') && document.querySelector('.view-products-panel.active')) {
        return;
      } else {
        if (document.body.classList.contains('open-search')) {
          document.body.classList.remove('open-search');
        }
        document.body.classList.remove('open-cc');
      }

      if (document.body.classList.contains('overflow-hidden')) {
        document.body.classList.remove('overflow-hidden');
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.button = document.getElementById('cart-drawer-toggle');

    // Add functionality to buttons
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.classList.add('active');
      this.focus();
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer-inner'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.querySelector('#CartDrawerTerms'),
      checkout_button = this.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = this.querySelector('#order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });

    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.querySelector(`#CartDrawerItem-${line}`)) {
          this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
      });
  }
}
customElements.define('cart-drawer', CartDrawer);

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('[id^="ModalClose-"]');

    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.closeButton.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER') {
          this.hide();
        }
      });
    }

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    if (this.dataset.moved) return;
    this.moved = true;
    document.body.appendChild(this);


    this.addEventListener('click', (e) => {
        const tab = e.target.closest('.tab-item');
        if (tab && this.contains(tab)) {
          const tabId = tab.dataset.tab;
          if (tabId) {
            this.activateTab(tabId);
          }
        }
    });
    

  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    setTimeout(() => {
      this.closeButton.focus();
    }, 100);

        // 切换对应 tab
    const targetTab = opener?.dataset?.tab; // 从按钮上读取 data-tab
    this.activateTab(targetTab);
    
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }

  activateTab(tabId) {

    const tabs = this.querySelectorAll('.tab-item'); // 你的 tab 按钮
    const panels = this.querySelectorAll('.tab-content'); // 对应 tab 内容区

    if (!tabs.length || !panels.length) return;


    tabs.forEach(tab => {
      if (tab.dataset.tab === tabId) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    panels.forEach(panel => {
      if (panel.dataset.tab === tabId) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });
  }

}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.quickviewCache = null; // 缓存
    }

    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('mouseenter', this.preloadQuickview.bind(this)); // 🟢 提前预加载
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));
    }

    setupCCEventListener() {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    }

    preloadQuickview() {
      if (this.quickviewCache) return; // 已经缓存过

      let productHandle = this.dataset.productHandle;
      if (!productHandle) return;

      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`.replace('//', '/');

      fetch(href)
        .then(r => r.text())
        .then(text => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const content = doc.querySelector('#Product-Drawer-Content');
          if (content) {
            this.quickviewCache = content.innerHTML; // 缓存 HTML
          }
        })
        .catch(console.error);
    }

    setupEventListener(e) {
      e.preventDefault();

      let productHandle = this.dataset.productHandle;
      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`.replace('//', '/');

      if (!href || !productHandle || this.disabled) return;
      if (this.classList.contains('loading')) return;

      this.classList.add('loading');

      // 🟢 优先用缓存
      if (this.quickviewCache) {
        this.renderQuickview(this.quickviewCache, href, productHandle);
        this.classList.remove('loading');
      } else {
        fetch(href, { method: 'GET' })
          .then((response) => {
            this.classList.remove('loading');
            return response.text();
          })
          .then(text => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const content = doc.querySelector('#Product-Drawer-Content');
            if (content) {
              this.quickviewCache = content.innerHTML; // 缓存
              this.renderQuickview(this.quickviewCache, href, productHandle);
            }
          })
          .catch(() => this.classList.remove('loading'));
      }
    }

    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML) return;

      const container = this.drawer.querySelector('#Product-Drawer-Content');
      container.innerHTML = sectionInnerHTML;

      // 🟢 避免重复加载 script
      container.querySelectorAll('script[src]').forEach(js_file => {
        if (!document.querySelector(`script[src="${js_file.src}"]`)) {
          let script = document.createElement('script');
          script.src = js_file.src;
          document.head.appendChild(script);
        }
      });

      this.body.classList.add('open-cc--product');
      this.drawer.classList.add('active');

      // 🟢 延迟执行非关键逻辑
      requestIdleCallback(() => {
        if (Shopify?.PaymentButton) Shopify.PaymentButton.init();
        if (window?.ProductModel) window.ProductModel.loadShopifyXR();
      });

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle: productHandle
      });
      addIdToRecentlyViewed(productHandle);
    }
  }

  customElements.define('quick-view', QuickView);
}


/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 *  Animations
 */
ScrollTrigger.batch('.animations-true .products .gallery--item figure, .animations-true .product-card .product-featured-image-link', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .multicolumn--column-inner', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { y: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .blog-post .featured-image--link', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .card--image', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

class TabCollectionSlider extends HTMLElement {
  constructor() {
    super();
    
    this.querySelectorAll('.tab-item').forEach((item, idx) => {
      item.addEventListener('click', (event) => {
        if (!event.target.classList.contains('active')) this.update(idx);
      });
      if (Shopify.designMode) {
        item.addEventListener('shopify:block:select', (event) => {
          if (!event.target.classList.contains('active')) this.update(idx);
        });
      }
    });
  }
  
  update(idx) {
    this.querySelector('.tab-item.active').classList.remove('active');
    this.querySelectorAll('.tab-item')[idx].classList.add('active');
    this.querySelector('.tab-pane.active').classList.remove('active');
    this.querySelectorAll('.tab-pane')[idx].classList.add('active');
  }
}
customElements.define('tab-collection-slider', TabCollectionSlider);

class CouponCode extends HTMLElement {
  constructor() {
    super();

    this.code = this.dataset.code;
    this.code && this.addEventListener('click', ()=> {
      this.copyToClipboard(this.code);
      this.innerText = 'copied!';
      this.timer = setTimeout(() =>{
        this.innerText = ' ';
        clearTimeout(this.timer);
      }, 1500);
    });
  }

  copyToClipboard(str) {
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    var selected =
        document.getSelection().rangeCount > 0
    ? document.getSelection().getRangeAt(0)
    : false;
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
  }
}
customElements.define('coupon-code', CouponCode);

function copyToClipboard(str) {
  var el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  var selected =
      document.getSelection().rangeCount > 0
  ? document.getSelection().getRangeAt(0)
  : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

function copyCode(e) {
  var $this = e.target;
  copyToClipboard($this.getAttribute('data-code'));
  $this.innerText = 'copied!';
  setTimeout(function() { $this.innerText = 'copy'; }, 1500);
}


class CopyCode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => this.copyToClipboard());
  }

  connectedCallback() {
    this.dataCode = this.dataset.code;
    this.codeId = this.dataset.codeId;
    this.url = this.dataset.url;
    this.autoRedirect = this.dataset.autoRedirect || false;
    this.delay = this.dataset.delay || 1500;

    if (!this.dataCode) {
      return;
    }
  }

  copyToClipboard() {
    const tempInput = document.createElement('input');
    tempInput.setAttribute('type', 'text');
    tempInput.setAttribute('readonly', true);
    tempInput.value = this.dataCode;
    tempInput.style.position = 'absolute';
    tempInput.style.opacity = 0;
    document.body.appendChild(tempInput);
    
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // 对于手机设备
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    this.showCopyMessage();
    this.delayedRedirect();
  }

  showCopyMessage() {
    const message = document.getElementById(`message--${this.codeId}`);
    message.style.display = 'inline-flex';
    setTimeout(() => {
      message.style.display = 'none';
    }, this.delay);
  }
  delayedRedirect(){
    if(this.url && this.autoRedirect == true){
      setTimeout(() => {
        window.location.href = this.url;
      }, this.delay);
    }
  }
}
customElements.define('copy-code', CopyCode);

(function(){
  document.body.addEventListener('click', function(e) {
    if (e.target.classList.contains('klarna-msg')) {
      e.preventDefault();
      var klarnaHtml = '<div class="modal-content" style="background-color: #fff; padding: 0 1rem 1rem 1rem;max-width: 600px;">'+
          '<div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><span><div class="country-US" style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: center; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; height: 60px; justify-content: center; opacity: 1;"><svg focusable="false" width="81" height="20" aria-hidden="true"><g transform="translate(0, 0) scale(1)"><path d="M78.3352549,14.3292706 C77.0678017,14.3292706 76.0403439,15.3567284 76.0403439,16.6243597 C76.0403439,17.8916348 77.0678017,18.9192707 78.3352549,18.9192707 C79.6027081,18.9192707 80.630344,17.8916348 80.630344,16.6243597 C80.630344,15.3567284 79.6027081,14.3292706 78.3352549,14.3292706" fill="#000"></path><path d="M70.7958568,7.22817345 L70.7958568,6.4467803 L74.4529833,6.4467803 L74.4529833,18.6618356 L70.7958568,18.6618356 L70.7958568,17.8811547 C69.7626656,18.5857975 68.5156063,19 67.1704277,19 C63.6107082,19 60.7250027,16.1142945 60.7250027,12.554575 C60.7250027,8.99485561 63.6107082,6.10915009 67.1704277,6.10915009 C68.5156063,6.10915009 69.7626656,6.52335256 70.7958568,7.22817345 Z M67.4697718,15.6974209 C69.3000267,15.6974209 70.7835696,14.2902722 70.7835696,12.554575 C70.7835696,10.8188779 69.3000267,9.41208536 67.4697718,9.41208536 C65.6395168,9.41208536 64.1559739,10.8188779 64.1559739,12.554575 C64.1559739,14.2902722 65.6395168,15.6974209 67.4697718,15.6974209 Z" fill="#000"></path><path d="M54.2263333,6.11823191 C52.765406,6.11823191 51.3828316,6.57178896 50.4584442,7.82312205 L50.4584442,6.4474926 L46.8169884,6.4474926 L46.8169884,18.6618356 L50.503141,18.6618356 L50.503141,12.2427657 C50.503141,10.3852653 51.7487757,9.47565814 53.2485235,9.47565814 C54.8558285,9.47565814 55.7798597,10.4358386 55.7798597,12.2174791 L55.7798597,18.6618356 L59.4327124,18.6618356 L59.4327124,10.8940256 C59.4327124,8.05141421 57.1725844,6.11823191 54.2263333,6.11823191" fill="#000"></path><path d="M41.5278044,8.03788051 L41.5278044,6.44695838 L37.7834212,6.44695838 L37.7834212,18.6618356 L41.536174,18.6618356 L41.536174,12.9588053 C41.536174,11.0347048 43.6216104,10.0004452 45.0686479,10.0004452 C45.0834281,10.0004452 45.097318,10.0018698 45.1120982,10.0020479 L45.1120982,6.44767068 C43.6269526,6.44767068 42.2609392,7.08357654 41.5278044,8.03788051" fill="#000"></path><path d="M32.2128788,7.22817345 L32.2128788,6.4467803 L35.8701833,6.4467803 L35.8701833,18.6618356 L32.2128788,18.6618356 L32.2128788,17.8811547 C31.1796876,18.5857975 29.9326283,19 28.5876277,19 C25.0279083,19 22.1422028,16.1142945 22.1422028,12.554575 C22.1422028,8.99485561 25.0279083,6.10915009 28.5876277,6.10915009 C29.9326283,6.10915009 31.1796876,6.52335256 32.2128788,7.22817345 Z M28.8867938,15.6974209 C30.7170487,15.6974209 32.2007697,14.2902722 32.2007697,12.554575 C32.2007697,10.8188779 30.7170487,9.41208536 28.8867938,9.41208536 C27.0567169,9.41208536 25.5729959,10.8188779 25.5729959,12.554575 C25.5729959,14.2902722 27.0567169,15.6974209 28.8867938,15.6974209 Z" fill="#000"></path><path d="M16.8150889 18.6618356 20.6429893 18.6618356 20.6429893 1.00338343 16.8150889 1.00338343z" fill="#000"></path><path d="M14.1770857,1 L10.2104649,1 C10.2104649,4.25111544 8.71570325,7.23511837 6.10957549,9.1873547 L4.53806353,10.3642524 L10.6271604,18.6673559 L15.6335612,18.6673559 L10.0307872,11.0272257 C12.6865979,8.38263373 14.1770857,4.82469505 14.1770857,1" fill="#000"></path><path d="M0 18.6666436 4.05334336 18.6666436 4.05334336 1 0 1z" fill="#000"></path></g></svg></div><h1 id="learn-more-title" role="heading" aria-level="1" style="max-width: 100%; margin: -5px 0px -10px; padding: 1px 0px 4px; box-sizing: border-box; flex-shrink: 0; text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; word-break: break-word; text-align: left; direction: ltr; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-size: 20px; font-weight: 700; line-height: 30px; letter-spacing: 0.3px; color: rgb(23, 23, 23); text-size-adjust: none;">Buy what you love and split the cost. It’s easy and interest-free.</h1><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; background-color: rgba(255, 255, 255, 0); width: 100%; height: 15px;"></div><div class="timeline"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; background-color: rgba(255, 255, 255, 0); width: 100%; height: 15px;"></div><div role="list" style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div role="listitem" style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: absolute; z-index: 0; min-height: 0px; min-width: 0px; width: 2px; background-color: rgb(240, 238, 235); height: 100%; top: 15px; left: 4px;"></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-top: 15px; padding-right: 15px;"><svg focusable="false" width="10" height="10"><rect width="10" height="10" fill="rgba(23, 23, 23, 1)"></rect></svg></div></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 1; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; width: 100%; padding-top: 15px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; padding-bottom: 4px; padding-top: 1px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 500; font-size: 16px; line-height: 20px; color: rgb(23, 23, 23); text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; white-space: pre-line; margin-bottom: -10px; margin-top: -5px; letter-spacing: 0px; text-size-adjust: none;">Add item(s) to your cart</p></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; color: rgb(120, 117, 115); font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 400; line-height: 20px; text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; text-align: left; word-break: break-word; margin-bottom: -10px; margin-top: -5px; padding-bottom: 4px; padding-top: 1px; letter-spacing: 0px; text-size-adjust: none;"></p></div></div></div><div role="listitem" style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: absolute; z-index: 0; min-height: 0px; min-width: 0px; width: 2px; background-color: rgb(240, 238, 235); height: 100%; top: 0px; left: 4px;"></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-top: 15px; padding-right: 15px;"><svg focusable="false" width="10" height="10"><rect width="10" height="10" fill="rgba(23, 23, 23, 1)"></rect></svg></div></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 1; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; width: 100%; padding-top: 15px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; padding-bottom: 4px; padding-top: 1px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 500; font-size: 16px; line-height: 20px; color: rgb(23, 23, 23); text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; white-space: pre-line; margin-bottom: -10px; margin-top: -5px; letter-spacing: 0px; text-size-adjust: none;">Go to checkout and choose <svg role="img" style="margin: -5px 5px; height: 30px; vertical-align: middle" focusable="false" viewBox="0 0 38 22" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>Klarna badge</title><path d="M34.9997,22.0004 L2.9997,22.0004 C1.3437,22.0004 -0.0003,20.6564 -0.0003,19.0004 L-0.0003,3.0004 C-0.0003,1.3434 1.3437,0.0004 2.9997,0.0004 L34.9997,0.0004 C36.6567,0.0004 37.9997,1.3434 37.9997,3.0004 L37.9997,19.0004 C37.9997,20.6564 36.6567,22.0004 34.9997,22.0004" fill="rgba(255, 179, 199, 1)"></path><path d="M30.5661,13.3275 C29.8181,13.3275 29.2121,12.7535 29.2121,12.0435 C29.2121,11.3345 29.8181,10.7605 30.5661,10.7605 C31.3141,10.7605 31.9201,11.3345 31.9201,12.0435 C31.9201,12.7535 31.3141,13.3275 30.5661,13.3275 L30.5661,13.3275 Z M31.9241,9.5485 L31.9241,9.8675 C31.5031,9.5795 30.9931,9.4105 30.4441,9.4105 C28.9891,9.4105 27.8101,10.5895 27.8101,12.0435 C27.8101,13.4985 28.9891,14.6775 30.4441,14.6775 C30.9931,14.6775 31.5031,14.5085 31.9241,14.2205 L31.9241,14.5395 L33.4201,14.5395 L33.4201,9.5485 L31.9241,9.5485 Z" fill="rgba(23, 23, 23, 1)"></path><path d="M8.7917,7.3226 L7.1707,7.3226 C7.1707,8.6506 6.5607,9.8706 5.4947,10.6686 L4.8537,11.1486 L7.3407,14.5416 L9.3867,14.5416 L7.0977,11.4196 C8.1827,10.3396 8.7917,8.8846 8.7917,7.3226" fill="rgba(23, 23, 23, 1)"></path><path d="M2.995,14.541 L4.655,14.541 L4.655,7.322 L2.995,7.322" fill="rgba(23, 23, 23, 1)"></path><path d="M9.869,14.539 L11.433,14.539 L11.433,7.324 L9.869,7.324" fill="rgba(23, 23, 23, 1)"></path><path d="M25.1549,9.4144 C24.5579,9.4144 23.9929,9.5994 23.6149,10.1104 L23.6149,9.5484 L22.1279,9.5484 L22.1279,14.5394 L23.6339,14.5394 L23.6339,11.9164 C23.6339,11.1574 24.1419,10.7854 24.7559,10.7854 C25.4119,10.7854 25.7899,11.1784 25.7899,11.9054 L25.7899,14.5394 L27.2819,14.5394 L27.2819,11.3654 C27.2819,10.2034 26.3589,9.4144 25.1549,9.4144" fill="rgba(23, 23, 23, 1)"></path><path d="M14.8014,13.3275 C14.0534,13.3275 13.4474,12.7535 13.4474,12.0435 C13.4474,11.3345 14.0534,10.7605 14.8014,10.7605 C15.5494,10.7605 16.1554,11.3345 16.1554,12.0435 C16.1554,12.7535 15.5494,13.3275 14.8014,13.3275 L14.8014,13.3275 Z M16.1604,9.5485 L16.1604,9.8675 C15.7384,9.5795 15.2294,9.4105 14.6794,9.4105 C13.2254,9.4105 12.0454,10.5895 12.0454,12.0435 C12.0454,13.4985 13.2254,14.6775 14.6794,14.6775 C15.2294,14.6775 15.7384,14.5085 16.1604,14.2205 L16.1604,14.5395 L17.6554,14.5395 L17.6554,9.5485 L16.1604,9.5485 Z" fill="rgba(23, 23, 23, 1)"></path><path d="M19.9665,10.1986 L19.9665,9.5486 L18.4365,9.5486 L18.4365,14.5396 L19.9695,14.5396 L19.9695,12.2096 C19.9695,11.4236 20.8215,11.0006 21.4125,11.0006 L21.4315,11.0006 L21.4315,9.5486 C20.8235,9.5486 20.2665,9.8076 19.9665,10.1986" fill="rgba(23, 23, 23, 1)"></path><path d="M35.0055,12.7689 C34.4875,12.7689 34.0685,13.1889 34.0685,13.7059 C34.0685,14.2249 34.4875,14.6449 35.0055,14.6449 C35.5235,14.6449 35.9425,14.2249 35.9425,13.7059 C35.9425,13.1889 35.5235,12.7689 35.0055,12.7689" fill="rgba(23, 23, 23, 1)"></path></svg></p></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; color: rgb(120, 117, 115); font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 400; line-height: 20px; text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; text-align: left; word-break: break-word; margin-bottom: -10px; margin-top: -5px; padding-bottom: 4px; padding-top: 1px; letter-spacing: 0px; text-size-adjust: none;"></p></div></div></div><div role="listitem" style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: absolute; z-index: 0; min-height: 0px; min-width: 0px; width: 2px; background-color: rgb(240, 238, 235); height: 100%; top: 0px; left: 4px;"></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-top: 15px; padding-right: 15px;"><svg focusable="false" width="10" height="10"><rect width="10" height="10" fill="rgba(23, 23, 23, 1)"></rect></svg></div></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 1; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; width: 100%; padding-top: 15px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; padding-bottom: 4px; padding-top: 1px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 500; font-size: 16px; line-height: 20px; color: rgb(23, 23, 23); text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; white-space: pre-line; margin-bottom: -10px; margin-top: -5px; letter-spacing: 0px; text-size-adjust: none;">Enter your debit or credit card information</p></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; color: rgb(120, 117, 115); font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 400; line-height: 20px; text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; text-align: left; word-break: break-word; margin-bottom: -10px; margin-top: -5px; padding-bottom: 4px; padding-top: 1px; letter-spacing: 0px; text-size-adjust: none;"></p></div></div></div><div role="listitem" style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: absolute; z-index: 0; min-height: 0px; min-width: 0px; width: 2px; background-color: rgb(240, 238, 235); height: 15px; top: 0px; left: 4px;"></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-top: 15px; padding-right: 15px;"><svg focusable="false" width="10" height="10"><rect width="10" height="10" fill="rgba(23, 23, 23, 1)"></rect></svg></div></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 1; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; width: 100%; padding-top: 15px;"><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; padding-bottom: 4px; padding-top: 1px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 500; font-size: 16px; line-height: 20px; color: rgb(23, 23, 23); text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; white-space: pre-line; margin-bottom: -10px; margin-top: -5px; letter-spacing: 0px; text-size-adjust: none;">Your first payment is taken when the order is processed and the remaining 3 are automatically taken every two weeks</p></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; padding-bottom: 15px;"><p style="max-width: 100%; color: rgb(120, 117, 115); font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 400; line-height: 20px; text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; text-align: left; word-break: break-word; margin-bottom: -10px; margin-top: -5px; padding-bottom: 4px; padding-top: 1px; letter-spacing: 0px; text-size-adjust: none;"></p></div></div></div></div></div><div style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; background-color: rgba(255, 255, 255, 0); width: 100%; height: 15px;"></div><p style="max-width: 100%; color: rgb(120, 117, 115); font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 400; font-size: 12px; line-height: 20px; text-rendering: geometricprecision; -webkit-font-smoothing: antialiased; text-align: left; word-break: break-word; margin-bottom: -10px; margin-top: -5px; padding-bottom: 4px; padding-top: 1px; letter-spacing: 0px; text-size-adjust: none;">See payment <a tabindex="0" aria-label="Klarna payment terms (Opens in a new window)" href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx" target="_blank" style="border-radius: 2px; color: rgb(120, 117, 115); cursor: pointer; font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Arial, sans-serif; font-weight: 400; outline: 0px; text-decoration: underline rgb(120, 117, 115); text-rendering: geometricprecision; transition: color 0.2s ease 0s; -webkit-font-smoothing: antialiased;">terms</a>. A higher initial payment may be required for some consumers. CA residents: Loans made or arranged pursuant to a California Financing Law license.</p></div></span></div>'+
          '<div class="modal-close"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M19 17.61l27.12 27.13m0-27.13L19 44.74"/></svg></div>'+
        '</div>';
      var klarnaModal = document.createElement('div');
      klarnaModal.classList.add('modal-box');
      klarnaModal.innerHTML = klarnaHtml;
      document.body.appendChild(klarnaModal);
      klarnaModal.addEventListener('click', function(e) { e.stopPropagation(); e.target == this &&  document.body.removeChild(klarnaModal) });
      klarnaModal.querySelector('.modal-close').addEventListener('click', function(e) { e.stopPropagation(); document.body.removeChild(klarnaModal) });
    }
    if (e.target.classList.contains('afterpay-msg')) {
      e.preventDefault();
      Afterpay.version && Afterpay.launchModal();
    }
  });
})();

/**
 *  @class
 *  @function LoopTimer
 */
if (!customElements.get('loop-timer')) {
class LoopTimer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // 获取模式：'daily'（当天结束）或 'fixed'（基于startTime循环），默认为 'fixed'
    this.mode = this.dataset.mode || 'fixed';
    
    // 获取循环时长（小时），默认为3小时
    this.durationHours = parseInt(this.dataset.duration) || 3;
    this.durationMs = this.durationHours * 60 * 60 * 1000;
    
    // 获取开始时间（ISO格式或时间戳），默认为当前时间
    this.startTime = this.dataset.startTime || new Date().toISOString();
    
    // 解析开始时间
    this.referenceTime = this.parseStartTime(this.startTime);
    
    this.startTimer();
    this._interval = setInterval(this.startTimer.bind(this), 1000);
  }

  parseStartTime(timeString) {
    // 如果是时间戳
    if (/^\d+$/.test(timeString)) {
      return parseInt(timeString);
    }
    
    // 如果是ISO格式时间
    const date = new Date(timeString);
    return date.getTime();
  }

  startTimer() {
    let timeDifference;
    
    if (this.mode === 'daily') {
      // 当天结束倒计时模式
      timeDifference = this.getDailyRemainingTime();
    } else {
      // 基于开始时间的循环倒计时模式
      timeDifference = this.getFixedLoopRemainingTime();
    }

    const hours = Math.floor(timeDifference / (60 * 60 * 1000));
    const mins = Math.floor((timeDifference % (60 * 60 * 1000)) / (60 * 1000));
    const secs = Math.floor((timeDifference % (60 * 1000)) / 1000);

    this.updateTimerDisplay(hours, mins, secs);
  }

  getFixedLoopRemainingTime() {
  const now = Date.now();
  const elapsed = now - this.referenceTime;

  if (elapsed < 0) {
    // startTime 在未来 → 倒计时从 duration 开始
    return this.durationMs;
  }

  // 计算在当前循环周期中的位置
  const positionInCycle = elapsed % this.durationMs;
  const remaining = this.durationMs - positionInCycle;

  return remaining;
}

  getDailyRemainingTime() {
    const offset = this.getTimezoneOffset();
    const now = new Date();

    // 当前 UTC 时间
    const utcNow = new Date(now.getTime() + now.getTimezoneOffset() * 60 * 1000);

    // 当前目标时区时间
    const targetNow = new Date(utcNow.getTime() + offset * 60 * 60 * 1000);

    // 当天结束时间（目标时区当天 24:00）
    const endOfDayTarget = new Date(targetNow);
    endOfDayTarget.setHours(24, 0, 0, 0);

    // 剩余时间（毫秒）
    return endOfDayTarget - targetNow;
  }

  getTimezoneOffset() {
    let timezone = this.dataset.timezone;

    // 未设置或 null -> 使用本地时区
    if (!timezone || timezone.toLowerCase() === "auto" || timezone.toLowerCase() === "null") {
      return -new Date().getTimezoneOffset() / 60;
    }

    const offset = parseInt(timezone, 10);
    return isNaN(offset) ? 0 : offset;
  }

  updateTimerDisplay(hours, mins, secs) {
    this.setDigits('.hours-num', hours);
    this.setDigits('.minutes-num', mins);
    this.setDigits('.seconds-num', secs);
  }

  setDigits(selector, value) {
    const element = this.querySelector(selector);
    if (!element) return;

    const str = String(value).padStart(2, '0');
    const [tens, units] = str;

    element.innerHTML = `
      <span class="digit tens">${tens}</span>
      <span class="digit units">${units}</span>
    `;
  }

  // 重置计时器（使用新的开始时间）
  resetTimer(newStartTime = null) {
    if (newStartTime) {
      this.startTime = newStartTime;
      this.referenceTime = this.parseStartTime(this.startTime);
    }
    this.startTimer();
  }

  // 更新设置
  updateSettings(mode, durationHours, timezone, startTime = null) {
    if (this._interval) clearInterval(this._interval);
    
    if (mode) this.dataset.mode = mode;
    if (durationHours) this.dataset.duration = durationHours;
    if (timezone) this.dataset.timezone = timezone;
    if (startTime) this.dataset.startTime = startTime;
    
    this.init();
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }
}

customElements.define('loop-timer', LoopTimer);
}

/**
 *  @class
 *  @function VideoControl
 */
if (!customElements.get('control-video')) {
	class ControlVideo extends HTMLElement {
		constructor() {
			super();
			this.played = false;
			this.toggle = this.querySelector('button.video__controls');
		}
		connectedCallback() {
			let _this = this;			
			// Video Support.
			this.video_container = this.querySelector('.video-section__container');

			if (this.video_container.querySelector('iframe')) {
				this.video_container.querySelector('iframe').onload = function () {
					_this.videoPlay();
				};
			}

			// Controls.
			if (this.toggle) {
				this.toggle.addEventListener('click', this.setupControlEvents.bind(this));
			}
		}

		setupControlEvents() {
			if (this.played){
                this.videoPause();				
				if (this.toggle) {
					this.toggle.classList.remove('played');
				}
			} else {
				this.videoPlay();
				if (this.toggle) {
					this.toggle.classList.add('played');
				}
			}
		}
		videoPlay() {
			setTimeout(() => {
				if (this.video_container.dataset.provider === 'youtube') {
					this.video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
						event: "command",
						func: "playVideo",
						args: ""
					}), "*");
				} else if (this.video_container.dataset.provider === 'vimeo') {
					this.video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
						method: "play"
					}), "*");
				} else if (this.video_container.dataset.provider === 'hosted') {
                    const video = this.video_container.querySelector('video')
					video.play();
				}

				this.played = true;
                  
			}, 10);
		}
		videoPause() {
			setTimeout(() => {
				if (this.video_container.dataset.provider === 'youtube') {
					this.video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
						event: "command",
						func: "pauseVideo",
						args: ""
					}), "*");
				} else if (this.video_container.dataset.provider === 'vimeo') {
					this.video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
						method: "pause"
					}), "*");
				} else if (this.video_container.dataset.provider === 'hosted') {
					this.video_container.querySelector('video').pause();
				}
				this.played = false;
			}, 10);
		}
	}
	customElements.define('control-video', ControlVideo);
}

/**
 *  @class
 *  @function PromoPoup
 *  自定义弹框
 */

if (!customElements.get('promo-popup')) {
class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'custom:promo-popup';

    this.classes = {
      bodyClass: 'overflow-hidden',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.popup = this.querySelector('.promo-popup');

    // Open modal if errors or success message exist
    if (this.querySelector('.form-notification')) {
      this.open();
    }

    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    const urlParams = new URLSearchParams(window.location.search);
    const utmSource =  urlParams.get('utm_source');
    this.params = this.getAttribute('data-params');

    if(this.params){
      if (utmSource === this.params && !this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
        this.init();
      }
    }else{
      if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
         this.init();
      }
    }    
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

      document.body.classList.remove(this.classes.bodyClass);
    }
  }
  onSectionLoad(event) {
    this.open();
  }
  onSectionSelect(event) {
    this.open();
  }
  onSectionDeselect(event) {
    this.close();
  }

  init() {
    if(!this.popup) {
      return;
    }
    
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function() {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    document.body.classList.remove(this.classes.bodyClass);
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 600);

    if (this.popup.dataset.position === 'center') {
      document.body.classList.add(this.classes.bodyClass);
    }
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.popup.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
    }, 500);

    // Remove a cookie in case it was set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }
    if(this.dataset.expiry > 0){
      this.setCookie(this.cookieName, this.dataset.expiry);
    }
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);
}

/*聊天框 */

window.addEventListener('load', () => {
  const chatElem = document.querySelector('#ShopifyChat');
  if (!chatElem) return;

  let timer = null;
  let isOpen = false; // 当前是否展开

  const showChat = () => {
    chatElem.style.transform = 'translateX(0)';
    isOpen = true;
  };

  const hideChat = () => {
    chatElem.style.transform = 'translateX(55%)';
    isOpen = false;
  };

  const delayedShow = (delay = 4000) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(showChat, delay);
  };

  // 页面加载后延迟显示
  delayedShow();
  const isPC = window.innerWidth > 768;

  if (isPC) {
    // PC端滚动触发隐藏，延迟显示
    window.addEventListener('scroll', () => {
      hideChat();
      delayedShow();
    });

    // PC端鼠标悬浮显示
    chatElem.addEventListener('mouseenter', showChat);

    // PC端点击显示
    chatElem.addEventListener('click', () => {
      if (!isOpen) showChat();
    });

  }

});


// 获取 Omnisend 转盘的折扣码并存到 localStorage，同时显示在客户页面Coupon列表
(function () {
  const STORAGE_KEY = "omnisendDiscountCodes";
  const MS_IN_DAY = 24 * 60 * 60 * 1000;
  const VALID_DAYS = 30;

  // ---- Utils ----
  const safeParseJSON = (str, fallback = []) => {
    try {
      return JSON.parse(str) || fallback;
    } catch {
      return fallback;
    }
  };

  const formatDate = (timestamp) =>
    new Date(timestamp).toLocaleDateString("en-US");

  // ---- Storage ----
  function saveDiscountCode(email, code) {
    if (!email || !code) return;

    let storedCodes = safeParseJSON(localStorage.getItem(STORAGE_KEY));

    // 已存在则不重复存
    if (storedCodes.some((item) => item.code === code)) {
      console.log("⚠️ 折扣码已存在:", code);
      return;
    }

    storedCodes.push({ code, time: Date.now() });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(storedCodes));
    console.log("✅ 已写入 localStorage:", storedCodes);

    renderDiscountCodes();
  }

  // ---- Render ----
  function renderDiscountCodes() {
    let storedCodes = safeParseJSON(localStorage.getItem(STORAGE_KEY));
    const now = Date.now();

    // 自动清理过期折扣码
    storedCodes = storedCodes.filter(
      (item) => now <= item.time + VALID_DAYS * MS_IN_DAY
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(storedCodes));

    storedCodes.forEach((item, index) => {
      const container = document.querySelector(
        `div[data-code-card="${item.code}"]`
      );
      if (!container) return;

      const startDate = formatDate(item.time);
      const endTime = item.time + VALID_DAYS * MS_IN_DAY;
      const endDate = formatDate(endTime);

      const { heading, discount, description } = container.dataset;

      container.style.display = "block";
      container.innerHTML = `
        <div class="card-wrapper">
          <div class="card-header card-item">${discount || ""}</div>
          <div class="card-content card-item">
            <h3 class="h6">${heading || ""}</h3>
            <div>${description || ""}</div>
            <div class="usage-time"><p>${startDate} - ${endDate}</p></div>
          </div>
          <div class="copy-button">
            <copy-code data-code="${item.code}" data-code-id="card-${index + 1}">Copy</copy-code>
          </div>
          <div id="message--card-${index + 1}" class="copy-message" style="display:none;">Copied!</div>
        </div>
      `;
    });
  }

  // ---- Intercept Fetch ----
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    if (
      typeof input === "string" &&
      input.includes("forms.soundestlink.com/REST/forms/v2/subscribe")
    ) {
      try {
        const email = init?.body ? JSON.parse(init.body).formData?.emailField : null;
        const response = await originalFetch(input, init);

        const data = await response.clone().json().catch(() => null);
        const discountCode = data?.discount?.code;

        saveDiscountCode(email, discountCode);

        return response;
      } catch (err) {
        console.error("❌ Omnisend 表单拦截失败:", err);
      }
    }
    return originalFetch(input, init);
  };

  // 页面加载时渲染 & 清理过期
  document.addEventListener("DOMContentLoaded", renderDiscountCodes);
})();


/* 购物车点击显示详细价格信息 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.main-cart-total svg');
  if (!trigger) return;

  const triggers = Array.from(document.querySelectorAll('.main-cart-total svg'));
  const index = triggers.indexOf(trigger);

  trigger.classList.toggle('active');
  const target = document.querySelectorAll('.cart-discount-info')[index];
  if (target) target.classList.toggle('active');
});

     /*
*无法点击的选项。在切换变体的时候，会自动将其顺延到其他可选的选项
*/
// 查找下一个有效的 radio 按钮
function findNextRadio(radio) {
  let next = radio.nextElementSibling;
  while (next && (next.classList.contains('is-disabled') || next.type !== 'radio')) {
    next = next.nextElementSibling;
  }
  return next;
}

// 查找前一个有效的 radio 按钮
function findPrevRadio(radio) {
  let prev = radio.previousElementSibling;
  while (prev && (prev.classList.contains('is-disabled') || prev.type !== 'radio')) {
    prev = prev.previousElementSibling;
  }
  return prev;
}

document.addEventListener('product:variant-change', (e) => {
  const optionGroups = document.querySelectorAll('.product-form__input input[type="radio"]');
  if (!optionGroups.length) return;

  // 将 NodeList 转为数组并倒序，确保从后往前检查
  const radios = Array.from(optionGroups).reverse();

  for (const radio of radios) {
    const isDisabled = radio.classList.contains('is-disabled');

    if (radio.checked && isDisabled) {

      const nextRadio = findNextRadio(radio);
      if (nextRadio) {
        nextRadio.click();
        return;
      }

      const prevRadio = findPrevRadio(radio);
      if (prevRadio) {
        prevRadio.click();
        return;
      }
      break;
    }
  }
});
